module.exports = __webpack_public_path__ + "img/abnormal.24089cdd.png";